// The njoy tenant every pre-whitelabel row belongs to. Seeded by the
// CreateTenants migration; fixed so code and data backfills can refer to it.
export const DEFAULT_TENANT_ID = "6172f785-d2c0-4cbd-8363-37272b78225d";

export enum TenantStatus {
  Active = "Active",
  Suspended = "Suspended",
  Provisioning = "Provisioning"
}

/**
 * How a tenant checks that people signing up are members. Null: anyone can
 * sign up.
 */
export enum MemberVerification {
  // Signup needs a CBM member ID that the CBM API reports as verified.
  Cbm = "cbm"
}

export interface TenantBranding {
  appName?: string;
  shortName?: string;
  logoUrl?: string;
  iconUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
  supportEmail?: string;
  websiteUrl?: string;
}

/** What GET /api/tenant-config returns: everything a frontend needs at boot. */
export interface PublicTenantConfig {
  id: string;
  name: string;
  slug: string;
  branding: TenantBranding;
  memberVerification: MemberVerification | null;
  /** Points-to-cash terms; null when points can't be spent on this tenant. */
  pointsToCash: {
    pointValue: number;
    maxSharePercent: number;
    minCashout: number;
  } | null;
  features: {
    wallet: boolean;
    points: boolean;
    referrals: boolean;
  };
}
